import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function MatchValidator(source: string, target: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const sourceCtrl = control.get(source);
        const targetCtrl = control.get(target);
        let sourceCtrlValue, targetCtrlValue;
        if (source === 'email') {
            sourceCtrlValue = sourceCtrl?.value.toLowerCase();
            targetCtrlValue = targetCtrl?.value.toLowerCase();
        } else {
            sourceCtrlValue = sourceCtrl?.value;
            targetCtrlValue = targetCtrl?.value;
        }
        if (sourceCtrl && targetCtrl && sourceCtrlValue !== targetCtrlValue) {
            targetCtrl.setErrors({ mustMatch: true });
            return { mustMatch: true };
        } else {
            targetCtrl?.updateValueAndValidity;
            return null;
        }
    };
}
